import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

const ContentDismissButton = ({
  label = 'Close',
  onClick,
  className,
  ...props
}) => {
  return (
    <button
      type="button"
      className={classNames('btn-content-dismiss', {
        [className]: !!className,
      })}
      onClick={onClick}
      {...props}
    >
      {label}
    </button>
  );
};

ContentDismissButton.propTypes = propTypes;

export default ContentDismissButton;
